import { createPlatformSiteAri } from '@townsquare/collab-context/create-site-ari';
import { createRelayResource, type RelayResourceConfig } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type {
	ResourceStoreContext,
	RouterContext,
	RouterDataContext,
} from '@townsquare/router/routing-types';
import type { HomeResourceContext } from '@townsquare/router/types';

import TeamDirectoryPageQuery, {
	type AggTeamDirectoryPageQuery as AggTeamDirectoryPageQueryType,
} from '../__generated__/AggTeamDirectoryPageQuery.graphql';

export const getTeamDirectoryResourceQuery = (
	_routerContext: RouterContext | RouterDataContext,
	resourceContext: ResourceStoreContext,
): RelayResourceConfig<AggTeamDirectoryPageQueryType> => {
	const context = resourceContext as HomeResourceContext;
	const siteId = context.collabContext?.rovoWorkspace || context.workspace?.cloudId || '';
	const scopeId = createPlatformSiteAri(siteId) ?? '';

	return {
		environment: getAggRelayEnvironment(),
		query: TeamDirectoryPageQuery,
		variables: {
			scopeId,
		},
		options: {
			fetchPolicy: 'store-and-network',
		},
	};
};

export const teamDirectoryResource = createRelayResource<AggTeamDirectoryPageQueryType>({
	getQuery: getTeamDirectoryResourceQuery,
});
